import { Injectable } from '@angular/core';
import { classes, pages } from '../shared/labels';
import { NavigationItem } from '../models/navigation-item-model';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  constructor() {}

  updateNavigationItems(
    navigationItems: any,
    patientFirstName: string,
    patientLastName: string,
    patientId: string,
    pageToBeHighlighted?: string,
    appointmentId?: string,
    appointmentTitle?: string
  ): NavigationItem[] {
    let patientLastNameWithFirstLetterMaiusc =
      patientLastName.charAt(0).toUpperCase() + patientLastName.slice(1);
    return navigationItems.map((item: any) => {
      if (
        item.label === 'Patient Name' ||
        item.label === patientLastNameWithFirstLetterMaiusc
      ) {
        return {
          label: patientLastName,
          class: classes.hb,
          route: '/pazienti/' + patientId,
          icon_path: 'assets/imgs/icons/user-yellow.svg',
        };
      } else if (item.label === pages.registry) {
        return {
          ...item,
          class:
            pageToBeHighlighted === pages.registry ? classes.hnb : classes.nhnb,
          route: '/pazienti/' + patientId + '/registry',
        };
      } else if (item.label === pages.medicalHistory) {
        return {
          ...item,
          class:
            pageToBeHighlighted === pages.medicalHistory
              ? classes.hnb
              : classes.nhnb,
          route: '/pazienti/' + patientId + '/medical-history',
        };
      } else if (item.label === pages.lifeLine) {
        return {
          ...item,
          class:
            pageToBeHighlighted === pages.lifeLine ? classes.hnb : classes.nhnb,
          route: '/pazienti/' + patientId + '/life-line',
        };
      } else if (item.label === pages.documents) {
        return {
          ...item,
          class:
            pageToBeHighlighted === pages.documents
              ? classes.hnb
              : classes.nhnb,
          route: '/pazienti/' + patientId + '/documents',
        };
      } else if (item.label === pages.aiFeatures) {
        return {
          ...item,
          class:
            pageToBeHighlighted === pages.aiFeatures
              ? classes.hnb
              : classes.nhnb,
          route: '/pazienti/' + patientId + '/funzioni-ai',
        };
      } else if (item.label === pages.interviewDetails) {
        return {
          ...item,
          label: appointmentTitle,
          route: '/pazienti/' + patientId + '/appointments/' + appointmentId,
        };
      } else {
        return item;
      }
    });
  }
}
